<div *ngIf="globalDisplay" class="connect-prime">

  <!--            FixMe: PrimeNG12Upgrade - need to add width 380x585 to the style-->
  <p-dialog (onHide)="onHideDialog($event)" [(visible)]="globalContext.display" [responsive]="true" [modal]="true" [draggable]="false"
            [style]="DialogStyle40" [contentStyle]="{'padding':'12px','margin':'0','padding-top':'15px','padding-bottom':'50px;'}" [closable]="false">
    <ng-template pTemplate="header">
      <div class="p-grid" style="width: 100%;">
        <div class="p-col-6 p-md-6 p-lg-6 connect-brand">
          <h2>
            <img src="assets/img/connect-ui-rev.png"/>
            <span>Connect</span>
          </h2>
        </div>

        <div align="center" class="p-col-6 p-md-6 p-lg-6 connect-selection">

          <div class="connect-overlay">

            <h3>
              <a (click)="onBack()" pTooltip="My Home">
                <i class="fa fa-home"></i>
              </a>
            </h3>

            <h3>
              <a (click)="groupUpdateAppear()" pTooltip="My Groups">
                <i class="fa fa-users"></i>
              </a>
            </h3>
            <h3>
              <a (click)="help.toggle($event)" pTooltip="My Groups">
                <i class="fa fa-question-circle" pTooltip="Help Topics"></i>
              </a>
            </h3>

            <!--
            <h3>
              <a>
                <i pTooltip="My Resources" class="fa fa-info"></i>
              </a>
            </h3>

            <h3>
              <a>
                <i class="fa fa-gear" pTooltip="Settings"></i>
              </a>
            </h3> -->

          </div>
        </div>
      </div>
    </ng-template>
    <!-- Home View -->
    <section>
      <div class="page-help-topics">
        <p-overlayPanel #help appendTo="body" [style]="{'width':'225px','background-color':'#efefef'}">
          <h4><i class="fa fa-question-circle"></i> Help Topics</h4>
          <ul style="list-style: none;padding:0;">
            <li style="font-style:italic;font-size: 14px;border-bottom:1px solid #ccc;margin-bottom:10px;">
              <a (click)="display23=true" style="text-decoration:none;color:#333;cursor:pointer;">How do I see an overview?</a>
            </li>
            <li style="font-style:italic;font-size: 14px;border-bottom:1px solid #ccc;margin-bottom:10px;">
              <a (click)="display24=true" style="text-decoration:none;color:#333;cursor:pointer;">How do I connect to a peer?</a>
            </li>
            <li style="font-style:italic;font-size: 14px;border-bottom:1px solid #ccc;margin-bottom:10px;">
              <a (click)="display25=true" style="text-decoration:none;color:#333;cursor:pointer;">How do I connect to a group?</a>
            </li>
            <li style="font-style:italic;font-size: 14px;border-bottom:1px solid #ccc;margin-bottom:10px;">
              <a (click)="display26=true" style="text-decoration:none;color:#333;cursor:pointer;">How do I connect to Chat Support?</a>
            </li>
          </ul>
        </p-overlayPanel>
        <p-dialog header="Show Me | Connect: Overview" [(visible)]="display23" [modal]="true" [responsive]="true" appendTo="body">
          <iframe *ngIf="display23" width="560" height="315" src="https://www.youtube.com/embed/vp0syC4t0Jo?start=0;autoplay=1" frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
        </p-dialog>
        <p-dialog header="Show Me | Connect: Connecting to a Peer" [(visible)]="display24" [modal]="true" [responsive]="true" appendTo="body">
          <iframe *ngIf="display24" width="560" height="315" src="https://www.youtube.com/embed/vp0syC4t0Jo?start=131;autoplay=1" frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
        </p-dialog>
        <p-dialog header="Show Me | Connect: Connecting to a Group" [(visible)]="display25" [modal]="true" [responsive]="true" appendTo="body">
          <iframe *ngIf="display25" width="560" height="315" src="https://www.youtube.com/embed/vp0syC4t0Jo?start=218;autoplay=1" frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
        </p-dialog>
        <p-dialog header="Show Me | Connect: Connecting to Chat Support" [(visible)]="display26" [modal]="true" [responsive]="true" appendTo="body">
          <iframe *ngIf="display26" width="560" height="315" src="https://www.youtube.com/embed/vp0syC4t0Jo?start=298;autoplay=1" frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
        </p-dialog>
      </div>
      <div class="p-grid">
        <div *ngIf="showHomePage" id="homeAppear" class="p-col-12 connect-box">
          <div style="text-align:left;">
            <p-autoComplete name="name" class="autoComplete" field="fullName" [placeholder]="Validation.AutoCompletePlaceholder"
                            [suggestions]="searchResults" [minLength]="Validation.AutoCompleteMinLength" [showEmptyMessage]="true"
                            (completeMethod)="searchUser($event)"
                            [(ngModel)]="friend" (onSelect)="process()"></p-autoComplete>
            <br>
            <div *ngIf="requestDiv" id="sendRequest">
              Send Request to User
              <button type="button" pButton class="button-inaction" (click)="noRequest()" label="No"></button>
              <button type="button" pButton class="button-action" (click)="sendRequest()" label="Yes"></button>

            </div>
          </div>
          <div align="left">
            <h4>Requests</h4>
          </div>
          <div class="connect-box" align="left" style="height: 75px; overflow-y: scroll;">

            <ul align="left">
              <li align="left" *ngFor="let request of reqListCombined">
                <span *ngIf="request.type == 'sent'">
                  <div>
                    <span *ngIf="request.status=='Add to Contacts'">
                      <a (click)="onSelectSent(request)">
                        <i class="fa fa-check" aria-hidden="true"></i>
                      </a> {{request.to}} </span>
                    <span *ngIf="request.status=='Pending'">
                      <i class="fa fa-share" aria-hidden="true"></i> {{request.to}} </span>
                  </div>
                </span>
                <span *ngIf="request.type == 'received'">
                  <div>
                    <button type="button" (click)="acceptRequest(request)">
                      <i class="fa fa-thumbs-up"></i>
                    </button>
                    <button type="button" (click)="rejectRequest(request)">
                      <i class="fa fa-thumbs-down"></i>
                    </button>
                    {{request.from}}
                  </div>
                </span>
                <span *ngIf="request.type == 'groupRequest'">
                  <div>
                    <button type="button" (click)="acceptGroupRequest(request)">
                      <i class="fa fa-thumbs-up"></i>
                    </button>
                    <button type="button" (click)="rejectGroupRequest(request)">
                      <i class="fa fa-thumbs-down"></i>
                    </button>
                    {{request.from}} Invited you to Join '{{request.channel}}'
                  </div>
                </span>
              </li>
            </ul>


          </div>
          <div align="left">
            <h4>Contacts</h4>
          </div>

          <div class="connect-box" align="left" style="height: 125px; overflow-y: scroll;padding:0;">

            <ul>
              <li *ngFor="let contact of contacts" class="p-grid connect-actionrow">

                <div class="connect-actionname p-col-4">
                  <i class="fa fa-circle-o" aria-hidden="true"></i> {{contact.unReadMessagesCount}} {{contact.userName}}
                </div>
                <div class="connect-actionbar p-col-8">
                  <a (click)="onSelectChatContact(contact)">
                    <i class="fa fa-comment"></i>
                  </a>
                  <a (click)="onSelectVideoContact(contact, 'VIDEO')">
                    <i class="fa fa-video-camera"></i>
                  </a>
                  <a (click)="onSelectVideoContact(contact, 'AUDIO')">
                    <i class="fa fa-phone"></i>
                  </a>
                  <a (click)="onSelectMailContact(contact)">
                    <i class="fa fa-envelope"></i>
                  </a>

                </div>


                <div>

                </div>
              </li>
            </ul>
          </div>

          <div align="left">
            <h4>Groups
              <a (click)="onClickAddGroup()">
                <i class="fa fa-plus" aria-hidden="true" style="font-size:14px;"></i>
              </a>
            </h4>

          </div>

          <div class="connect-box" align="left" style="height: 100px; overflow-y: scroll;">
            <ul>
              <li *ngFor="let group of groups" class="p-grid" style="margin-right:0;">
                <div class="connect-actionname p-col-6">
                  <p-header>
                    {{group.channelName}}
                  </p-header>
                </div>
                <div class="connect-actionbar p-col-6">
                  <a (click)="onSelectGroupChat(group)">
                    <i class="fa fa-comment"></i>
                  </a>
                  <a (click)="onSelectGroupVideo(group,'VIDEO')">
                    <i class="fa fa-video-camera"></i>
                  </a>
                  <a (click)="onSelectGroupVideo(group,'AUDIO')">
                    <i class="fa fa-phone"></i>
                  </a>
                  <a (click)="onSelectGroupMail(group)">
                    <i class="fa fa-envelope"></i>
                  </a>
                  <a (click)="showGroupInfo(group)">
                    <i class="fa fa-info"></i>
                  </a>
                </div>
              </li>
            </ul>
          </div>

        </div>

        <div id="groupInfoAppear" class="p-col-12 connect-box" *ngIf="selectedGroupInfo && showGroupInfoAppearPage">
          <div align="left">
            <label> {{selectedGroupInfo.channelName}} </label>
            <br>
            <label> Members</label>
            <div class="connect-box" align="left" style="width: 100%!important; height: 200px; overflow-y: scroll;">
              <ul>
                <li *ngFor='let member1 of selectedGroupInfo.channelMembers '>
                  <span *ngIf="member1.acceptStatus == 'Accepted'">
                    <span *ngIf="member1.userId == user.info.userId"> You
                      <a (click)="deleteSelfFromGroup(member1)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </a>
                    </span>
                    <span *ngIf="member1.userId != user.info.userId"> {{member1.userName}} </span>
                  </span>
                </li>
              </ul>

            </div>
          </div>

        </div>

        <div *ngIf="showChatAppearPage" id="chatAppear" class="p-col-12 connect-box">
          <div align="left" class="connect-box1">
            <a (click)="onBack()">
              <i class="fa fa-arrow-left fa-2x" aria-hidden="true"></i>
            </a>
            <strong style="font-size: 20px; font-family:monospace"> Chat With {{userClicked}} </strong>

          </div>
          <div id="chatbox" #scrollMe [scrollTop]="scrollMe.scrollHeight">
            <ul>
              <li *ngFor='let chat of chatList '>
                <span *ngIf="chat.type == 'Message'">
                  <font size="2">
                    <strong> {{chat.from}} </strong>
                    <font size="2"> {{chat.time}} </font>
                    <br> <font size="3">{{chat.message}}</font>
                  </font>
                </span>
                <span align="center" *ngIf="chat.type == 'GroupAdd'">
                  <hr>
                  <font size="2"> {{chat.message}} </font>
                  <hr>
                </span>
                <span align="center" *ngIf="chat.type == 'GroupDelete'">
                  <hr>
                  <font size="2"> {{chat.message}} </font>
                  <hr>
                </span>
              </li>
            </ul>

          </div>


          <textarea pInputTextarea class="message-field" (keyup.enter)="publish()" [(ngModel)]="msg" [rows]="1" placeholder="Message @{{userClicked}} " style="max-width:100%;"></textarea>
          <div align="left" class="bottom-icons">
            <!-- <a>
              <i class="fa fa-video-camera"></i>
            </a>
            <a>
              <i class="fa fa-phone"></i>
            </a>
            <a href="mailto:">
              <i class="fa fa-envelope"></i>
            </a> -->
            <span align="right">
              <button style="float:right" type="button" class="button-action" pButton (click)="publish()" label="Send"></button>
            </span>
          </div>

        </div>

        <div *ngIf="showGroupAddAppearPage" id='groupAppear' class="p-col-12 connect-box" style="margin-bottom:10px;">
          Group Name*:
          <input type="text" pInputText [(ngModel)]="newGroupName"/>
          <div style="margin-top:10px;vertical-align: top;">Add Members:
            <p-autoComplete name="groupName" class="autoComplete" field="fullName" [placeholder]="Validation.AutoCompletePlaceholder"
                            [suggestions]="searchResults" [minLength]="Validation.AutoCompleteMinLength" [showEmptyMessage]="true" [multiple]="true"
                            (completeMethod)="searchUser($event)"
                            [(ngModel)]="newGroupMembers"
            ></p-autoComplete>
          </div>
          <div style="position:relative;bottom: -25px;left:-7px;padding:15px;text-align: right;background-color:#F7F7EE;width:103%;border-top:1px solid #ccc;">
            <button [disabled]="newGroupName == '' " type="button" class="button-action" pButton (click)="processNewGroup()" label="Add" icon="fa fa-check"></button>
          </div>
        </div>

        <div style="float:left" id='groupUpdate' class="p-col-12 connect-box" *ngIf="selectedGroupInfo && showGroupUpdatePage">
          <!-- GroupName: <input type="text" pInputText [(ngModel)]="newGroupName" /> <br> -->
          <div align="left">
            <label style="margin-top:8px;margin-right:8px;">Your Groups</label>
            <p-dropdown [options]="groupsDropDown" placeholder="Select Group" [(ngModel)]="selectedGroup"></p-dropdown>
            <button [disabled]="selectedGroup.channelName == '' " type="button" class="icon-negative" (click)="deleteGroup()">
              <i class="fa fa-trash"></i>
            </button>
            <div>
              <label style="margin:10px 0 0 0;padding:0"> Members</label>
            </div>
          </div>
          <div class="connect-box" align="left" style="width: 100%; height: 200px; overflow-y: scroll;margin:0 0 15px 0;">

            <li *ngFor='let member1 of selectedGroup.channelMembers '>
              {{member1.userName}} -
              <span *ngIf="member1.acceptStatus == 'Accepted' && member1.userId != selectedGroup.ownerId ">
                <a (click)="deleteMember(member1)">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </a>
              </span>
              <span *ngIf="member1.acceptStatus == 'Rejected'"> Rejected </span>
              <span *ngIf="member1.acceptStatus == 'Pending'"> Pending </span>
            </li>
          </div>
          <div align="left" class="add-member">
            <label style="margin-right:8px;"> Add Member</label>
            <p-autoComplete name="addMember" class="autoComplete" field="fullName" [placeholder]="Validation.AutoCompletePlaceholder"
                            [suggestions]="searchResults" [minLength]="Validation.AutoCompleteMinLength" [showEmptyMessage]="true"
                            (completeMethod)="searchUser($event)"
                            [(ngModel)]="newGroupMember"></p-autoComplete>
            <button pButton class="secondary-action" [disabled]="newGroupMember == undefined " (click)="addMember()" icon="fa fa-plus"></button>
          </div>
          <div style="position:relative;bottom: -14px;left:-7px;padding:15px;text-align: right;background-color:#F7F7EE;width:103%;border-top:1px solid #ccc;">
            <div align="right">
              <button type="button" class="button-inaction" pButton (click)="groupUpdateAppear()" label="Cancel" icon="fa fa-close"></button>
              <button [disabled]="!selectedGroup" class="button-action" type="button" pButton (click)="updateGroup()" label="Update" icon="fa fa-check"></button>
            </div>
          </div>
        </div>

      </div>
    </section>

  </p-dialog>

  <p-confirmDialog></p-confirmDialog>
  <p-dialog header="Call" [(visible)]="videoCallObject.visible" [responsive]="true" [modal]="true" [style]="DialogStyle200x300">

    <label> {{videoCallObject.callType}} Call From {{videoCallObject.from}} </label>
    <br>
    <button (click)="attendCall()" pTooltip="Phone">
      <i class="fa fa-check-circle-o" aria-hidden="true"></i>
    </button>
    <button (click)="rejectCall()" pTooltip="Phone">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>

  </p-dialog>


</div>
